import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { LoadingOverlay } from "@mantine/core";
import { findMe } from "@/services/user";
import { FindMeResponse } from "@/types/api/user";

export function RequireAdmin() {
  const [status, setStatus] = useState<"loading" | "authorized" | "forbidden" | "unauthenticated">("loading");

  useEffect(() => {
    findMe()
      .then((user: FindMeResponse) => {
        const isAdmin = user.permissions.includes("all_permissions");
        setStatus(isAdmin ? "authorized" : "forbidden");
      })
      .catch(() => setStatus("unauthenticated"));
  }, []);

  if (status === "loading") return <LoadingOverlay visible />;
  if (status === "unauthenticated") return <Navigate to="/auth/sign-in" replace />;
  if (status === "forbidden") return <Navigate to="/dash/home" replace />;

  return <Outlet />;
}
